import { useEffect, useState } from 'react';
import { makeStyles, ButtonBase } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import { TabBar } from '../../components';
import { i18n } from '../../language';
import { AddIcon } from '../../components/Icon';
import { NOTIFICATION_MESSAGE, NOTIFICATION_TAB } from '../../comm/constant';
import { authNameE } from '../../utils/userFuncs';
import { systemAPI } from '../../apis';
import { seenAndRefreshNotificationTotal } from '../../redux/actions';
import Notifycation from './components/Notification';
import NewNotificationPop from './components/pop/NewNotificationPop';
import { notifyP } from './bsApp';
import Scheduled from './components/Scheduled';

const useStyle = makeStyles((theme) => ({
  root: {
    top: '4.375rem',
    left: '6.25rem',
    right: '0',
    bottom: '1.25rem',
    display: 'flex',
    position: 'fixed',
    flexDirection: 'column',
    margin: '1.75rem 3.438rem 0 ',
  },

  head: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '1.875rem',
  },
  addIcon: {
    fontSize: '1rem',
    marginRight: '0.75rem',
  },
  composeBtn: {
    color: theme.palette.font.white,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: '500',
    backgroundColor: theme.palette.primary.main,
    width: '8.813rem',
    height: '3rem',
    borderRadius: '10px',
  },
}));

const NotificationBtn = ({ roleMap, classes, composeHandle }) => {
  return (
    roleMap?.[authNameE.notification_publish_notification] && (
      <div className={classes.head}>
        <ButtonBase className={classes.composeBtn} onClick={composeHandle} id="Notification-ButtonBase-aaa">
          <AddIcon className={classes.addIcon} />
          {i18n.t('NOTIFICATION_COMPOSE')}
        </ButtonBase>
      </div>
    )
  );
};

function Notification({ refreshNotificationTotal }) {
  const classes = useStyle();
  const roleMap = useSelector((state) => state.roleMap);
  const loginInfo = useSelector((state) => state.loginInfo);
  const [sendFlag, setSendFlag] = useState(false);

  // refresh notification total
  useEffect(() => {
    refreshNotificationTotal();
  }, []);

  useEffect(() => {
    refreshNotificationTotal();
  }, [loginInfo.wardId]);

  const [isNewNotificationPop, setIsNewNotificationPop] = useState(false);
  const composeHandle = () => {
    setIsNewNotificationPop(true);
  };
  const closePop = () => {
    setIsNewNotificationPop(false);
  };

  const sendHandle = async (sendData) => {
    try {
      await systemAPI.createSysNotification(sendData);
      setSendFlag(true);

      closePop();
    } catch {}
  };

  const setTabStatus = (data) => {
    setTabData(
      tabData.map((item, i) => {
        if (data[item.id]) {
          return { ...item, status: Boolean(data[item.id].status), flag: Boolean(data[item.id].flag) };
        } else {
          return item;
        }
      })
    );
  };

  const initTab = () => {
    const tabId = sessionStorage.getItem(NOTIFICATION_TAB);
    const tabs = [
      // {
      //   id: notifyP.systemAlert,
      //   falg: false,
      //   // component: () => <SystemAlert setTabStatus={setTabStatus} sendFlag={sendFlag} setSendFlag={setSendFlag}/>,
      //   title: i18n.t('NOTIFICATION_SYSTEM_ALERT'),
      //   status: false,
      // },
      {
        id: notifyP.notification,
        testID: notifyP.notification,
        falg: false,
        // component: () => <Notifycation setTabStatus={setTabStatus} sendFlag={sendFlag} setSendFlag={setSendFlag} />,
        title: i18n.t('NOTIFICATION_NOTIFICATION'),
        status: false,
      },
      {
        id: notifyP.scheduled,
        testID: notifyP.scheduled,
        falg: false,
        title: i18n.t('NOTIFICATION_SCHEDULED'),
        status: false,
      },
    ].filter((item) => {
      if (item.id === notifyP.scheduled) {
        return roleMap?.[authNameE.notification_publish_notification];
      }
      return true;
    });
    let i = 0;
    for (; i < tabs.length; i++) {
      if (tabs[i].id === tabId) {
        tabs[i].flag = true;
        break;
      }
    }
    if (i === tabs.length) {
      tabs[0].flag = true;
      sessionStorage.setItem(NOTIFICATION_TAB, tabs[0].id);
    }
    return tabs;
  };
  const [tabData, setTabData] = useState(initTab());
  useEffect(() => {
    setTabData(initTab());
  }, [roleMap]);
  if (tabData.length >= 1) tabData[0].title = i18n.t('NOTIFICATION_NOTIFICATION');
  if (tabData.length >= 1)
    tabData[0].component = <Notifycation setTabStatus={setTabStatus} sendFlag={sendFlag} setSendFlag={setSendFlag} />;
  if (tabData.length >= 2) tabData[1].title = i18n.t('NOTIFICATION_SCHEDULED');
  if (tabData.length >= 2)
    tabData[1].component = <Scheduled setTabStatus={setTabStatus} sendFlag={sendFlag} setSendFlag={setSendFlag} />;

  useEffect(() => {
    if (!loginInfo.flag) {
      if (!localStorage.getItem(NOTIFICATION_MESSAGE)) {
        localStorage.setItem(
          NOTIFICATION_MESSAGE,
          JSON.stringify({ [notifyP.notification]: 0, [notifyP.systemAlert]: 0 })
        );
      }
    }
  }, [loginInfo.flag]);

  return (
    <div className={classes.root}>
      <TabBar
        data={tabData}
        id="Notification-TabBar-aab"
        setData={(tabs) => {
          sessionStorage.setItem(NOTIFICATION_TAB, tabs.find((item) => item.flag)?.id);
          setTabData(tabs);
        }}
        NotificationBtn={<NotificationBtn roleMap={roleMap} classes={classes} composeHandle={composeHandle} />}
      />
      {isNewNotificationPop && (
        <NewNotificationPop
          id="Notification-NewNotificationPop-aac"
          open={isNewNotificationPop}
          closePop={closePop}
          sendHandle={sendHandle}
          refreshNotificationTotal={refreshNotificationTotal}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  refreshNotificationTotal: () => {
    dispatch(seenAndRefreshNotificationTotal());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
